import { ProductSetup, Organisation } from '@futrli-sdk/organisations';
import { Workspace, WorkspacesListingItem } from '@futrli-sdk/workspaces';

import { differenceInHours } from 'date-fns';

/**
 * Checks if the given product setup is pro. If the is_pro flag is true return that,
 * otherwise determine the trial status.
 *
 * @param {ProductSetup} product
 * @param {number} trialPeriodHours
 * @returns {boolean}
 */
export const checkIsPro = (product: ProductSetup, trialPeriodHours: number): boolean => {
  if (product.is_pro) {
    return product.is_pro;
  }

  return isInTrialPeriod(product, trialPeriodHours);
};

/**
 * Determines if the given product setup is within the provided trial period.
 *
 * @param {ProductSetup} product
 * @param {number} trialPeriodHours
 * @returns {boolean}
 */
export const isInTrialPeriod = (product: ProductSetup, trialPeriodHours: number): boolean => {
  const created = product.created || '1970-01-01T00:00:00.000Z';
  const createdDate = new Date(created);
  const diff = differenceInHours(Date.now(), createdDate);
  return diff < Number(trialPeriodHours);
};

/**
 * Determines if the organisation has deactivated at date in past (legacy active) .
 *
 * @param {Organisation} organisation
 * @param {Workspace} workspace
 * @returns {boolean}
 */
export const isOrgLegacyActive = (organisation: Organisation, workspace: Workspace | WorkspacesListingItem): boolean =>
  Boolean(
    workspace.subscription_state === 'active' &&
      organisation.legacy_deactivated_at &&
      new Date().getTime() > new Date(organisation.legacy_deactivated_at).getTime()
  );
